import React, { createContext, useEffect, useState } from "react"
import { PlayerRatingScope } from "components/ReviewAudit/PublicRatings"
import { entryUser, identifiedPlayer } from "components/ReviewAudit/PublicRatingScope"
import { get } from "helpers/api_helper"

export const DrawPlayerContext = createContext({})

const playerIds = (competition, mainDraw, registrationEntries) => {
  const entries = [
    ...registrationEntries,
    ...(competition?.luckyDraw || []).map(row => row.slot),
    ...(competition?.phases || []).flatMap(phase => (phase.luckyDraw || []).map(row => row.slot)),
  ]
  const matches = [...(mainDraw?.qualifications || []), ...(mainDraw?.matches || []).flat(), ...(mainDraw?.phases || []).flat()]
  return [...new Set([
    ...entries.flatMap(entry => [entryUser(entry), entry?.partner]).filter(identifiedPlayer).map(person => person.userId),
    ...(mainDraw?.allGroupPhasePlayers || []).flatMap(person => [person, person.partner]).filter(identifiedPlayer).map(person => person.userId),
    ...matches.flatMap(row => [row.player, row.playerPartner, row.opponent, row.opponentPartner]).filter(identifiedPlayer).map(person => person.userId),
  ].filter(id => /^\d+$/.test(String(id))).map(String))].sort().join(",")
}

// One request per batch of unique players, including doubles partners and later phases.
// Keep only display fields in page state; never update registration or match snapshots.
export default function DrawPlayerDetails({ competition, mainDraw, entries = [], children }) {
  const ids = playerIds(competition, mainDraw, entries)
  const [result, setResult] = useState({})
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let active = true
    const load = async () => {
      const players = {}
      try {
        const list = ids ? ids.split(",") : []
        for (let start = 0; start < list.length; start += 100) {
          const batch = list.slice(start, start + 100)
          const query = new URLSearchParams({ userIds: batch.join(","), limit: String(batch.length), page: "1" })
          const response = await get(`/accounts?${query}`, { timeout: 15000 })
          if (!active) return
          if (!Array.isArray(response?.data?.results)) throw new Error("Player details unavailable")
          response.data.results.forEach(({ userId, birthDate, phone, location }) => {
            if (batch.includes(String(userId))) players[userId] = { userId, birthDate, phone, location }
          })
        }
        if (active) setResult({ ids, players })
      } catch {
        if (active) setResult({ ids, players, failed: true })
      }
    }
    load()
    return () => { active = false }
  }, [ids, attempt])
  const current = result.ids === ids ? result : {}
  return <PlayerRatingScope players={ids ? ids.split(",").map(userId => ({ userId })) : []}><DrawPlayerContext.Provider value={current.players || {}}>
    {current.failed && <p role="status" className="text-muted">Some player details could not be loaded.{" "}
      <button type="button" className="btn btn-link btn-sm" onClick={() => setAttempt(value => value + 1)}>Retry player details</button>
    </p>}
    {children}
  </DrawPlayerContext.Provider></PlayerRatingScope>
}
